<template>
    <transition name="show-transition">
        <div class="user-ratings" v-if="open">
                <img class="user-ratings__header-img" src="./../../img/logos/holiday-check-logo.png" alt="Holiday Check">
                <div class="user-ratings__item" v-for="(rating, ratingKey) in ratingsList" :key="ratingKey">
                    <div class="user-ratings__item__icon">
                        <img :src="rating.img" alt="">
                    </div>
                    <p><span v-text="rating.name"></span> <span class="user-ratings__item__number" v-text="rating.value"></span></p>
                </div>
            </div>
    </transition>
</template>

<script>
import _ from 'underscore';

export default {
    props: {
        rating: {type: [Array, Object], default() {return {}}},
        open: {type: Boolean, default: false}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.USER_RATINS,
            isOpen: false
        }
    },
    mounted() {
        window.addEventListener('touchstart', this.onClick.bind(this));
    },
    beforeDestroy() {
        window.removeEventListener('touchstart', this.onClick.bind(this));
    },
    methods: {
        onClick(evt) {
            this.$nextTick(() => {
                if(this.$el && !this.$el.contains(evt.target) && this.isOpen) {
                    this.$emit('close');
                }
            })
        }
    },
    watch: {
        open() {
            if(this.open) {
                setTimeout(() => {
                    this.isOpen = true;
                }, 250);
            } else {
                this.isOpen = false;
            }
        }
    },
    computed: {
            ratingsList() {
                if(_.isEmpty(this.rating)) {
                    return [ ];
                }

                let ratings = [ ];
                for(let i in this.translations.recommendations) {
                    let value = this.rating[i];
                    if(i !== 'count')
                        value += '%';

                    ratings.push({
                        img: APP_CONFIG.THEME_PATH + '/assets/img/icons/user-ratings/icon-' + i + '.svg',
                        name: this.translations.recommendations[i],
                        value
                    })
                }

                return ratings;
            }
    }
}
</script>

